import React from "react";
import styled from "@emotion/styled";
import { IconButton } from "@mui/material";
import { Add, Check } from "@mui/icons-material";
import { Tooltip } from "./Tooltip";

const SelectedButton = styled(IconButton)`
    color: ${props => "#ffffff"};
    background: ${props => props.theme.palette.success.main};

    &:hover {
        background: ${props => props.theme.palette.error.main};
    }
`;

const UnselectedButton = styled(IconButton)`
    background: ${props => props.theme.palette.grey[200]};

    &:hover {
        color: ${props => "#ffffff"};
        background: ${props => props.theme.palette.success.main};
    }
`;

interface Props {
    isSelected: boolean;
    select: () => void;
    deselect: () => void;
    selectTooltip?: string;
    deselectTooltip?: string;
}

export const SelectButton = ({ isSelected, select, deselect, selectTooltip, deselectTooltip }: Props) => {
    return (
        <>
            {isSelected ?
                <Tooltip text={deselectTooltip} text_id="common.deselect">
                    <SelectedButton size="small" onClick={deselect}>
                        <Check />
                    </SelectedButton>
                </Tooltip> :
                <Tooltip text={selectTooltip} text_id="common.select">
                    <UnselectedButton size="small" onClick={select}>
                        <Add />
                    </UnselectedButton>
                </Tooltip>
                }
        </>
    );
}